import React, { useEffect, useMemo, useState } from "react";
import "./campaign-view-details-view-open-activities-info.scss";
import TaskImage from "../../../../../../assets/icons/tasks.svg";
import MeetingImage from "../../../../../../assets/icons/meetings.svg";
import CallsImage from "../../../../../../assets/icons/phone.svg";
import CommonTaskDialog from "./common-dialog-task/common-dialog-task";
import { CampaignViewDetailsViewViewOpenActivitiesInfoProps } from "./campaign-view-details-view-open-activities-info.props";
import { deleteMeeting, editMeeting, getCalls, getMeetings, getTasks } from "../../../../../../api/campaign";
import { formatDate, formatDateTime } from "../../../../../../utils/utils";
import DataTable from "./task-table/task-table";
import { IconButton, Tooltip } from "@mui/material";
import EditIcon from "../../../../../../assets/icons/edit.svg";
import { useSetLoading } from "../../../../../../common/hooks/appearance";
import {
  AlertComponent,
  ConfirmationPopup,
} from "../../../../../../common/components";
import DoneIcon from "../../../../../../assets/icons/green-tick.svg";
import { breadcrumbLink } from "../../../../campaign-list/campaign.constant";
import ViewTask from "./view-task/view-task";
import ConfirmInfo from "../../../../../../assets/icons/CreateLeadCapturePopupCancelIcon.svg";
import { editTask, deleteTask } from "../../../../../../api/campaign";
import archiveIcon from "../../../../../../assets/icons/archive-icon.svg";
import CommonMeetingDialog from "./common-dialog-task/common-meeting-dialog";
import { getCallColumns, getMeetingColumns } from "./common-dialog-task/common-dialog-helper";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { set } from "lodash";
import CommonCallDialog from "./common-dialog-task/common-dailog-call";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ActionsMenu from "../../../../../../common/components/mui-table/actions-menu";
import AddNewCallDropdown from "./add-call-dropdown";
import CommonRescheduleCallDialog from "./common-dialog-task/reshedule-call";
import CancelCallDialog from "./common-dialog-task/cancel-call";
import { deleteCall, getAssignedPeopleList } from "../../../../../../api/campaign";
import CommonCallLogDialog from "./common-dialog-task/common-dailouge-call-log";
import { useLogin } from "../../../../../../common/hooks/useUser";
import EmailSetUpBanner from "../../../../../../common/components/email-setup-required-banner/email-setup-banner";

const TAB_OPTIONS = [
  { label: "Tasks", icon: TaskImage, countKey: "tasksCount" },
  { label: "Meetings", icon: MeetingImage, countKey: "meetingsCount" },
  { label: "Calls", icon: CallsImage, countKey: "callsCount" },
];

type Meeting = {
  id: number;
  title: string;
  location: string;
  allDay: boolean;
  from: string;
  to: string;
  host: string;
  relatedTo: string;
  description: string;
  reminder: boolean;
  reminderAmPm: string;
  reminderDate: string;
  reminderHour: string;
  reminderMinute: string;
};

const CampaignViewDetailsViewActivitiesInfo: React.FC<
  CampaignViewDetailsViewViewOpenActivitiesInfoProps
> = (props: any) => {
  const {
    campaignDetails,
    setViewTaskvalue,
    setCrumbMappingOption,
    permissions,
    setViewMeetingvalue,
    setRefreshTaskView,
    setViewCallValue,
  } = props;

  const [activeTab, setActiveTab] = useState("Tasks");
  const [closedActiveTab,setClosedActiveTab] = useState("Tasks");
  const [openTaskDialog, setOpenTaskDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [editDataTask, setEditDataTask] = useState<any>(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState<"success" | "error">("success");
  const [tasksCount, setTasksCount] = useState(0);
  const [meetingsCount, setMeetingsCount] = useState(0);
  const [callsCount, setCallsCount] = useState(0);
  const [viewOpen, setViewOpen] = useState<boolean>(false);
  const [selectedTaskId, setSelectedTaskId] = useState<any>(null);
  // const [crumbMappingOption, setCrumbMappingOption] =
  //   useState<any>(breadcrumbLink);
  const [isMarkPopupOpen, setIsEditPopupOpen] = useState(false);
  const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
  const [selectedArchiveTask, setSelectedArchiveTask] = useState<any>(null);
  const [completedTasks, setCompletedTasks] = useState([]);
  const [taskToDelete, setTaskToDelete] = useState<any>(null);
  const [openMeetingDialog, setOpenMeetingDialog] = useState(false);
  const [meetings, setMeetings] = useState<Meeting[]>([]);
  const [editDataMeeting, setEditDataMeeting] = useState<any>(null);
  const [isArchivePopupOpenForMeeting, setIsArchivePopupOpenForMeeting] = useState(false);
  const [completedMeetings, setCompletedMeetings] = useState([]);
  const [meetingToDelete, setMeetingToDelete] = useState<any>(null);
  const [openCallsDialog, setOpenCallsDialog] = useState(false);
  const [openLogCallDialog, setOpenLogCallDialog] = useState(false);
  const [editDataCall, setEditDataCall] = useState<any>(null);
  const [calls, setCalls] = useState([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [menuRow, setMenuRow] = useState<any>(null);
  const [selectedOption, setSelectedOption] = useState("");
  const [rescheduleCallOpen, setRescheduleCallOpen] = useState(false);
  const [markCallAsCompletedOpen, setMarkCallAsCompletedOpen] = useState(false);
  const [cancelCallOpen, setCancelCallOpen] = useState(false);
  const [completedCalls, setCompletedCalls] = useState([]);
  const [isArchiveForCallPopupOpen, setIsArchiveForCallPopupOpen] = useState(false);  
  const [callToDelete, setCallToDelete] = useState<any>(null);
  const [customerOptions, setCustomerOptions] = useState<any[]>([]);
  const [openCallsCount, setOpenCallsCount] = useState(0);
  const [closedCallsCount, setClosedCallsCount] = useState(0);
  const [closedTasksCount, setClosedTasksCount] = useState(0);
  const [closedMeetingsCount, setClosedMeetingsCount] = useState(0);
  const loginDetails = useLogin();
  const isEmailConfigured = loginDetails?.isEmailConfigured;
  
  const handleAlertClose = () => {
    setAlertOpen(false);
  };
  const meetingColumns = getMeetingColumns(campaignDetails);

  const taskColumns = [
    {
      key: "subject",
      label: "Subject",
      render: (task: any) => task.subject,
    },
    {
      key: "due_date",
      label: "Due Date",
      render: (task: any) => formatDate(task.due_date),
    },
    {
      key: "owner",
      label: "Owner",
      render: (task: any) =>
        task.owner ? `${task.owner.first_name} ${task.owner.last_name}` : "-",
    },
    {
      key: "status",
      label: "Status",
      render: (task: any) => task.status,
    },
    {
      key: "priority",
      label: "Priority",
      render: (task: any) => task.priority,
    },
  ];
  const completedTaskColumns = [
    {
      key: "subject",
      label: "Subject",
      render: (task: any) => task.subject,
    },
    {
      key: "due_date",
      label: "Due Date",
      render: (task: any) => task.due_date ? formatDate(task.due_date) : "-",
    },
    {
      key: "owner",
      label: "Owner",
      render: (task: any) => task.owner
        ? `${task.owner.first_name} ${task.owner.last_name}`:"-"
    },
    {
      key: "priority",
      label: "Priority",
      render: (task: any) => task.priority,
    },
    {
      key: "closedTime",
      label: "Closed Time",
      render: (task: any) => formatDateTime(task.closed_time) || "-",
    },
  ];
  const handleeditDataTask = (task: any) => {
    setEditDataTask(task);
    setOpenTaskDialog(true);
  };
  const handleDoneTask = (task: any) => {
    setSelectedArchiveTask(task);
    setIsEditPopupOpen(true);
  };
  const handleMarkTaskCompleted = async () => {
    if (!selectedArchiveTask) return;
    setLoading(true);
    try {
      const updatedTask = {
        subject: selectedArchiveTask.subject,
        ownerId: selectedArchiveTask.owner_id,
        dueDate: selectedArchiveTask.due_date,
        priority: selectedArchiveTask.priority,
        status: "Completed",
        description: selectedArchiveTask.description,
        reminder: selectedArchiveTask.reminder,
        reminderDescription: selectedArchiveTask.reminder_description || "",
        relatedToCampaignId: selectedArchiveTask.related_to_campaign_id,
      };
      await editTask(selectedArchiveTask.id, updatedTask);

      setAlertMessage("Task marked as completed.");
      setAlertType("success");
      setAlertOpen(true);
      fetchTasks();
    } catch (error) {
      setAlertMessage("Failed to mark task as completed.");
      setAlertType("error");
      setAlertOpen(true);
    } finally {
      setIsEditPopupOpen(false);
      setSelectedArchiveTask(null);
    }
  };

  const handleDeleteTask = (task: any) => {
    setTaskToDelete(task);
    setIsArchivePopupOpen(true);
  };
  const confirmDeleteTask = async () => {
    if (!taskToDelete) return;
    setLoading(true);
    try {
      await deleteTask(taskToDelete.id);
      setAlertMessage("Task archived successfully.");
      setAlertType("success");
      setAlertOpen(true);
      fetchTasks();
    } catch (error) {
      setAlertMessage("Failed to archive task.");
      setAlertType("error");
      setAlertOpen(true);
    } finally {
      setIsArchivePopupOpen(false);
      setTaskToDelete(null);
      setLoading(false);
    }
  };


  const handleAddNewClick = () => {
    if (activeTab === "Tasks") {
      setOpenTaskDialog(true);
      setEditDataTask(null);
    }
    if (activeTab === "Meetings") {
      setOpenMeetingDialog(true);
      setEditDataMeeting(null);
    }
  };

  const handleOptionChange = (e: any) => {
    setSelectedOption(e.target.value);
    if (activeTab === "Calls") {
      setEditDataCall(null);
      if (e.target.value === "logCall") {
        setOpenLogCallDialog(true);
        setMarkCallAsCompletedOpen(false);
      }
      else if (e.target.value === "scheduleCall") {
        setOpenCallsDialog(true);
      } 
      else setOpenLogCallDialog(false);
    }
   }
 
  const fetchTasks = async () => {
    if (!campaignDetails?.id) return;

    setLoading(true);
    try {
      const response = await getTasks(
        { campaignId: campaignDetails.id },
        "View Campaigns"
      );
      const allTasks = response?.data?.data?.tasks || [];

      const open = allTasks.filter((task: any) => task.status !== "Completed");
      const completed = allTasks.filter(
        (task: any) => task.status === "Completed"
      );
      setTasks(open);
      setCompletedTasks(completed);
      setTasksCount(response?.data?.data?.count || 0);
      setClosedTasksCount(completed?.length || 0);
    } catch (error) {
      setAlertMessage("Failed to fetch task. Please try again.");
      setAlertType("error");
      setAlertOpen(true);
    } finally {
      setLoading(false);
    }
  };
  const handleeditDataMeeting = (meeting: any) => {
    setEditDataMeeting(meeting);
    setOpenMeetingDialog(true);
  };
  const handleDeleteMeeting = (meeting: any) => {
    setMeetingToDelete(meeting);
    setIsArchivePopupOpenForMeeting(true);
  };
  const confirmDeleteMeeting = async () => {
    if (!meetingToDelete) return;
    setLoading(true);
    try {
      await deleteMeeting(meetingToDelete.id);
      setAlertMessage("Meeting archived successfully.");
      setAlertType("success");
      setAlertOpen(true);
      fetchMeetings();
    } catch (error) {
      setAlertMessage("Failed to archive meeting.");
      setAlertType("error");
      setAlertOpen(true);
    } finally {
      setIsArchivePopupOpenForMeeting(false);
      setMeetingToDelete(null);
      setLoading(false);
    }
  };

  const fetchMeetings = async () => {
    if (!campaignDetails?.id) return;

    setLoading(true);
    try {
      const openMeetings = await getMeetings(
        { campaignId: campaignDetails.id, type: 'open' },
        "View Campaigns"
      );
      const openMeetingsList = openMeetings?.data?.data?.meetings || [];
      const closedMeetings = await getMeetings(
        { campaignId: campaignDetails.id, type: 'closed' },
        "View Campaigns"
      );
      const closedMeetingsList = closedMeetings?.data?.data?.meetings || [];
      setMeetings(openMeetingsList);
      setCompletedMeetings(closedMeetingsList);
      setMeetingsCount(openMeetings?.data?.data?.count || 0);
      setClosedMeetingsCount(closedMeetingsList?.length || 0);
    } catch (error) {
      setAlertMessage("Failed to fetch task. Please try again.");
      setAlertType("error");
      setAlertOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const fetchCalls = async (type = "open") => {
    if (!campaignDetails?.id) return;
    setLoading(true);
    try {
      const response = await getCalls(
        { campaignId: campaignDetails.id, type: type },
        "View Campaigns"
      );
      let allCalls = response?.data?.data?.calls || [];
      if (type === "closed") {
        allCalls = allCalls.filter(
          (call: any) => call?.outgoing_call_status === "Completed" || call?.outgoing_call_status === "Cancelled"
        );
        setCompletedCalls(allCalls);
        setClosedCallsCount(allCalls?.length)
      } else {
        setCalls(allCalls);
        setOpenCallsCount(response?.data?.data?.count || 0);
      }
    } catch (error) {
      setAlertMessage("Failed to fetch calls. Please try again.");
      setAlertType("error");
      setAlertOpen(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchAllCalls = async () => {
      await fetchCalls("open");
      await fetchCalls("closed");
    };
    if (activeTab === "Tasks") {
      fetchTasks();
      fetchMeetings();
      fetchAllCalls();
    }
    if (activeTab === "Meetings") {
      fetchMeetings();
    }
    if (activeTab === "Calls") {
      fetchAllCalls()
    }
  }, [activeTab, campaignDetails?.id]);

  useEffect(() => {
    const fetchAllCalls = async () => {
      // await fetchCalls("open");
      await fetchCalls("closed");
    };
    if (closedActiveTab === "Tasks") {
      fetchTasks();
      fetchMeetings();
      fetchAllCalls();
    }
    if (closedActiveTab === "Meetings") {
      fetchMeetings();
    }
    if (closedActiveTab === "Calls") {
      fetchAllCalls()
    }
  }, [closedActiveTab, campaignDetails?.id]);

  const callColumns = getCallColumns();

  const handleeditDataCall = (call: any) => {
    setEditDataCall(call);
    if (!call?.call_duration)setOpenCallsDialog(true);
    else setOpenLogCallDialog(true);
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>, row: any) => {
    setAnchorEl(event.currentTarget);
    setMenuRow(row);
    setEditDataCall(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setMenuRow(null);
  };

  const handleAction = (actionType: string, id: number) => {
    if (actionType === "Reschedule Call") {
      setRescheduleCallOpen(true);
    }
    if (actionType === "Mark As Completed") {
      setMarkCallAsCompletedOpen(true);
      setOpenLogCallDialog(true);
    }
    if(actionType === "Cancel Call") {
      setCancelCallOpen(true);
    }
  }

  const handleMenuOptionClick = (option: any) => {
      if (handleAction) handleAction(option?.label, menuRow?.id);
      handleClose();
  };

  const getActionTypes = (row: any, permissions: any) => { 
    return [
      {
        label: "Mark As Completed",
        value: "markAsCompleted",
        id: 1,
        disabled: !permissions?.canWrite,
      },
      {
        label: "Reschedule Call",
        value: "rescheduleCall",
        id: 2,
        disabled: !permissions?.canWrite,
      },
      {
        label: "Cancel Call",
        value: "cancelCall",
        id: 3,
        disabled: !permissions?.canWrite,
      },
    ];
  }

  const findTitleForCallDailog = () => {
    if (openLogCallDialog && !markCallAsCompletedOpen) {
      return "Log Call";
    } else if(markCallAsCompletedOpen) {
      return "Complete Call";
    }
    else return "Schedule Call"
  };

  const handleDeleteCall = (call: any) => {
    setCallToDelete(call);
    setIsArchiveForCallPopupOpen(true);
  };

  const confirmDeleteCall = async () => {
    if (!callToDelete) return;
    setLoading(true);
    try {
      await deleteCall(callToDelete.id);
      setAlertMessage("Call archived successfully.");
      setAlertType("success");
      setAlertOpen(true);
      fetchCalls("closed");
    } catch (error) {
      setAlertMessage("Failed to archive call.");
      setAlertType("error");
      setAlertOpen(true);
    } finally {
      setIsArchiveForCallPopupOpen(false);
      setCallToDelete(null);
      setLoading(false);
    }
  };

   const fetchAssignedPeople = async () => {
      try {
        const response = await getAssignedPeopleList(campaignDetails?.id);
        if (response.status === 200 && response.data.success) {
          const formattedOptions = response?.data?.data?.map(
            (item: any) => ({
              value: item.id || null,
              label: item?.fullName  || "",
              email: item?.primaryEmail || "",
              avatar: item?.profileUrl || null,
              resource: item?.resource || null,
            })
          );
          setCustomerOptions(formattedOptions);
        }
      } catch (error: any) {
        console.error("Error while fetching customers:", error);
        setAlertMessage(
          error?.response?.data?.message ||
          "Failed to fetch customers. Please try again."
        );
        setAlertType("error");
        setAlertOpen(true);
        return [];
      }
    };

  useEffect(() => {
    if (activeTab === "Calls") {
      fetchAssignedPeople();
    }
  }, [activeTab, campaignDetails?.id]);  

  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);

  return (
    <>
      <div className="campaign-view-details-view-open-activities-info">
        <div className="campaign-view-details-view-open-activities-info-header">
          <div className="campaign-view-details-view-open-activities-info-header-text">
            Open Activities
          </div>
          {activeTab !== "Calls" && <div>
            <button
              className="campaign-view-details-view-open-activities-info-header-button"
              onClick={handleAddNewClick}
              disabled={!permissions?.canWrite || !isEmailConfigured}
            >
              Add New
            </button>
          </div>}
          {activeTab === "Calls" &&
            <div className="campaign-list-view-details-view-box-attachment-info-header">
              <div className="add-new-call-dropdown">
                <AddNewCallDropdown
                  selectedOption={selectedOption}
                  handleChange={handleOptionChange}
                  disabled={!permissions?.canWrite || customerOptions.length === 0 || !isEmailConfigured}
                />
              </div>
            </div>
          }
        </div>
        {!isEmailConfigured && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              padding:"0px 16px 0px 16px",
            }}
          >
            <EmailSetUpBanner />
          </div>
        )}
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          className="mui-tabs-container"
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: '#887952',
            },
          }}
        >
          {TAB_OPTIONS.map((tab) => {
            const count =
              tab.label === "Tasks"
                ? tasksCount
                : tab.label === "Meetings"
                  ? meetingsCount
                  : openCallsCount

            return (
              <Tab
                key={tab.label}
                sx={{
                  "&.Mui-selected": {
                    color: "#212121",
                  },
                  textTransform: "none",
                }}
                label={
                  <div className="mui-tab-label">
                    <img src={tab.icon} alt={`${tab.label} icon`} className="icon-task" />
                    {tab.label} <span className="tab-count">{count}</span>
                  </div>
                }
                value={tab.label}
              />
            );
          })}
        </Tabs>
        {activeTab === "Tasks" && (
          <div className="campaign-view-details-view-open-activities-info-content">
            {tasks && tasks.length > 0 ? (
              <DataTable
                columns={taskColumns}
                data={tasks}
                rowActions={(task) => (
                  <div
                    style={{ display: "flex" }}
                    className={`${!permissions?.canWrite ? "Mui-disabled " : ""}`}
                  >
                    <Tooltip className="tooltip" title="Edit">
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        handleeditDataTask(task);
                      }}
                      className="icon-button"
                      disabled={!permissions?.canWrite}
                    >
                      <img src={EditIcon} alt="edit" className="img-icon" />
                    </IconButton>
                    </Tooltip>
                    <Tooltip className="tooltip" title="Mark as completed">
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDoneTask(task);
                      }}
                      className="icon-button"
                      disabled={!permissions?.canWrite}
                    >
                      <img src={DoneIcon} alt="delete" className="img-icon" />
                    </IconButton>
                    </Tooltip>
                  </div>
                )}
                onRowClick={(rowData: any) => {
                  setViewTaskvalue({ open: true, taskId: rowData.id });
                  setCrumbMappingOption((prev: any) => {
                    const crumbData = [...prev];
                    crumbData[prev?.length - 1].handleClick = (event: any) => {
                      setViewTaskvalue({ open: false, taskId: null });
                      event.preventDefault();
                      setCrumbMappingOption(prev);
                      // setViewOpen(false);
                    };
                    return [...crumbData, { label: rowData.subject, link: "" }];
                  });
                }}
              />
            ) : (
              <div className="campaign-view-details-view-open-activities-info-no-data">
                No Record Found
              </div>
            )}
          </div>
        )}
        {activeTab === "Meetings" && (
          <div className="campaign-view-details-view-open-activities-info-content">
            {meetings && meetings.length > 0 ? (
              <DataTable
                columns={meetingColumns}
                data={meetings}
                rowActions={(meeting) => (
                  <div style={{ display: "flex" }}>
                    <Tooltip className="tooltip" title="Edit">
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          handleeditDataMeeting(meeting);
                        }}
                        className="icon-button"
                        disabled={!permissions?.canWrite}
                      >
                        <img src={EditIcon} alt="edit" className="img-icon" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip className="tooltip" title="Archive">
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteMeeting(meeting);
                        }}
                        className="icon-button"
                        disabled={!permissions?.canDelete}
                      >
                        <img src={archiveIcon} alt="archive" className="img-icon" />
                      </IconButton>
                    </Tooltip>
                  </div>
                )}
                onRowClick={(rowData: any) => {
                  setViewMeetingvalue({ open: true, meetingId: rowData.id });
                  setCrumbMappingOption((prev: any) => {
                    const crumbData = [...prev];
                    crumbData[prev?.length - 1].handleClick = (event: any) => {
                      setViewMeetingvalue({ open: false, meetingId: null });
                      event.preventDefault();
                      setCrumbMappingOption(prev);
                      // setViewOpen(false);
                    };
                    return [...crumbData, { label: rowData.title, link: "" }];
                  });
                }}
              />
            ) : (
              <div className="campaign-view-details-view-open-activities-info-no-data">
                No Record Found
              </div>
            )}
          </div>
        )}
        {activeTab === "Calls" && (
          <div className="campaign-view-details-view-open-activities-info-content">
            {calls && calls.length > 0 ? (
              <>
                <DataTable
                  columns={callColumns}
                  data={calls}
                  rowActions={(call) => (
                    <div style={{ display: "flex" }}>
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          handleeditDataCall(call);
                        }}
                        className="icon-button"
                        disabled={!permissions?.canWrite}
                      >
                        <img src={EditIcon} alt="edit" className="img-icon" />
                      </IconButton>
                      <IconButton
                        className="icon-button"
                        disabled={!permissions?.canWrite}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleMenuClick(e, call)
                        }}
                      >
                        <MoreVertIcon />
                      </IconButton>
                    </div>
                  )}
                  onRowClick={(rowData: any) => {
                    setViewCallValue({ open: true, callId: rowData.id });
                    setCrumbMappingOption((prev: any) => {
                      const crumbData = [...prev];
                      crumbData[prev?.length - 1].handleClick = (event: any) => {
                        setViewCallValue({ open: false, callId: null });
                        event.preventDefault();
                        setCrumbMappingOption(prev);
                      };
                      return [...crumbData, { label: "View Call", link: "" }];
                    });
                  }}
                />
                <ActionsMenu
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  onOptionClick={handleMenuOptionClick}
                  options={getActionTypes(
                    menuRow,
                    permissions
                  )}
                  width="170px"
                />
              </>
            ) : (
              <div className="campaign-view-details-view-open-activities-info-no-data">
                No Record Found
              </div>
            )}
          </div>
        )}
      </div>

      <div className="campaign-view-details-view-open-activities-info">
        <div className="campaign-view-details-view-open-activities-info-header">
          <div className="campaign-view-details-view-open-activities-info-header-text">
            Closed Activities
          </div>
        </div>
        <Tabs
          value={closedActiveTab}
          onChange={(e, newValue) => setClosedActiveTab(newValue)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          className="mui-tabs-container"
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: '#887952',
            },
          }}
        >
          {TAB_OPTIONS.map((tab) => {
            const count =
              tab.label === "Tasks"
                ? closedTasksCount
                : tab.label === "Meetings"
                  ? closedMeetingsCount
                  : closedCallsCount

            return (
              <Tab
                key={tab.label}
                sx={{
                  "&.Mui-selected": {
                    color: "#212121",
                  },
                  textTransform: "none",
                }}
                label={
                  <div className="mui-tab-label">
                    <img src={tab.icon} alt={`${tab.label} icon`} className="icon-task" />
                    {tab.label} <span className="tab-count">{count}</span>
                  </div>
                }
                value={tab.label}
              />
            );
          })}
        </Tabs>
        {closedActiveTab === "Tasks" && (
          <div className="campaign-view-details-view-open-activities-info-content">
            {completedTasks && completedTasks.length > 0 ? (
              <DataTable
                columns={completedTaskColumns}
                data={completedTasks}
                rowActions={(task) => (
                  <div style={{ display: "flex" }}>
                    <Tooltip className="tooltip" title="Archive">
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteTask(task);
                        }}
                        className="icon-button"
                        disabled={!permissions?.canDelete}
                      >
                        <img
                          src={archiveIcon}
                          alt="archive"
                          className="img-icon"
                        />
                      </IconButton>
                    </Tooltip>
                  </div>
                )}
                onRowClick={(rowData: any) => {
                  setViewTaskvalue({ open: true, taskId: rowData.id });
                  setCrumbMappingOption((prev: any) => {
                    const crumbData = [...prev];
                    crumbData[prev?.length - 1].handleClick = (event: any) => {
                      setViewTaskvalue({ open: false, taskId: null });
                      event.preventDefault();
                      setCrumbMappingOption(prev);
                      // setViewOpen(false);
                    };
                    return [...crumbData, { label: rowData.subject, link: "" }];
                  });
                }}
              />
            ) : (
              <div className="campaign-view-details-view-open-activities-info-no-data">
                No Record Found
              </div>
            )}
          </div>
        )}
        {closedActiveTab === "Meetings" && (
          <div className="campaign-view-details-view-open-activities-info-content">
            {completedMeetings && completedMeetings.length > 0 ? (
              <DataTable
                columns={meetingColumns}
                data={completedMeetings}
                rowActions={(meeting) => (
                  <div style={{ display: "flex" }}>
                    <Tooltip className="tooltip" title="Archive">
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteMeeting(meeting);
                        }}
                        className="icon-button"
                        disabled={!permissions?.canDelete}
                      >
                        <img src={archiveIcon} alt="archive" className="img-icon" />
                      </IconButton>
                    </Tooltip>
                  </div>
                )}
                onRowClick={(rowData: any) => {
                  setViewMeetingvalue({ open: true, meetingId: rowData.id });
                  setCrumbMappingOption((prev: any) => {
                    const crumbData = [...prev];
                    crumbData[prev?.length - 1].handleClick = (event: any) => {
                      setViewMeetingvalue({ open: false, meetingId: null });
                      event.preventDefault();
                      setCrumbMappingOption(prev);
                      // setViewOpen(false);
                    };
                    return [...crumbData, { label: rowData.title, link: "" }];
                  });
                }}
              />
            ) : (
              <div className="campaign-view-details-view-open-activities-info-no-data">
                No Record Found
              </div>
            )}
          </div>
        )}
        {closedActiveTab === "Calls" && (
          <div className="campaign-view-details-view-open-activities-info-content">
            {completedCalls && completedCalls.length > 0 ? (
              <>
                <DataTable
                  columns={callColumns}
                  data={completedCalls}
                  rowActions={(call) => (
                    <div style={{ display: "flex" }}>
                      <IconButton
                        className="icon-button"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteCall(call);
                        }}
                        disabled={!permissions?.canDelete}
                      >
                        <img src={archiveIcon} alt="archive" className="img-icon" />
                      </IconButton>
                    </div>
                  )}
                  onRowClick={(rowData: any) => {
                    setViewCallValue({ open: true, callId: rowData.id });
                    setCrumbMappingOption((prev: any) => {
                      const crumbData = [...prev];
                      crumbData[prev?.length - 1].handleClick = (event: any) => {
                        setViewCallValue({ open: false, callId: null });
                        event.preventDefault();
                        setCrumbMappingOption(prev);
                      };
                      return [...crumbData, { label: "View Call", link: "" }];
                    });
                  }}
                />
                <ActionsMenu
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  onOptionClick={handleMenuOptionClick}
                  options={getActionTypes(
                    menuRow,
                    permissions
                  )}
                  width="170px"
                />
              </>
            ) : (
              <div className="campaign-view-details-view-open-activities-info-no-data">
                No Record Found
              </div>
            )}
          </div>
        )}
      </div>

      {/* Dialog for Task only */}
      {activeTab === "Tasks" && (
        <CommonTaskDialog
          open={openTaskDialog}
          onClose={() => {
            setOpenTaskDialog(false);
            setEditDataTask(null);
          }}
          campaignDetails={campaignDetails}
          onSave={() => {
            fetchTasks();
            setOpenTaskDialog(false);
            setEditDataTask(null);
          }}
          title={editDataTask ? "Edit Task" : "Create Task"}
          initialTask={editDataTask}
        />
      )}
      {activeTab === "Meetings" && (
        <CommonMeetingDialog
          open={openMeetingDialog}
          onClose={() => {
            setOpenMeetingDialog(false);
            setEditDataMeeting(null);
          }}
          campaignDetails={campaignDetails}
          onSave={() => {
            fetchMeetings();
            setOpenMeetingDialog(false);
            setEditDataMeeting(null);
          }}
          title={editDataMeeting ? "Edit Meeting" : "Create Meeting"}
          initialMeeting={editDataMeeting}
        />
      )}
      {activeTab === "Calls" && (
        <>
          {
            <CommonCallDialog
              open={openCallsDialog}
              onClose={() => {
                setOpenCallsDialog(false);
                setEditDataCall(null);
                setSelectedOption("");
              }}
              campaignDetails={campaignDetails}
              onSave={() => {
                fetchCalls();
                setOpenCallsDialog(false);
                setEditDataCall(null);
                setSelectedOption("");
              }}
              title={findTitleForCallDailog()}
              initialCall={editDataCall}
              isLogCall={openLogCallDialog}
              customerOptions={customerOptions}
              markCallAsCompletedOpen={markCallAsCompletedOpen}
            />}
          { <CommonCallLogDialog
            open={openLogCallDialog}
            onClose={() => {
              setEditDataCall(null);
              setOpenLogCallDialog(false);
              setMarkCallAsCompletedOpen(false);
              setSelectedOption("");
            }}
            campaignDetails={campaignDetails}
            onSave={() => {
              fetchCalls("open");
              fetchCalls("closed");
              setOpenLogCallDialog(false);
              setMarkCallAsCompletedOpen(false);
              setEditDataCall(null);
              setSelectedOption("");
            }}
            title={findTitleForCallDailog()}
            initialCall={editDataCall}
            isLogCall={openLogCallDialog}
            customerOptions={customerOptions}
            markCallAsCompletedOpen={markCallAsCompletedOpen}
          />}
        </>)}
      
      <AlertComponent
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={handleAlertClose}
      />
      <div className="mark-completed">
        <ConfirmationPopup
          open={isMarkPopupOpen}
          onCancel={() => setIsEditPopupOpen(false)}
          onOkay={handleMarkTaskCompleted}
          title="Mark Completed"
          note="Are you sure you want to mark this task as completed?"
          buttonText="Confirm"
          Icon={ConfirmInfo}
          className="mark-completed-confirmation"
        />
      </div>
      <div className="mark-completed">
        <ConfirmationPopup
          open={isArchivePopupOpen}
          onCancel={() => {
            setIsArchivePopupOpen(false);
            setTaskToDelete(null);
          }}
          onOkay={confirmDeleteTask}
          title="Archive Task"
          note={
            taskToDelete
              ? `Are you sure you want to archive "${taskToDelete.subject}"?`
              : "Are you sure you want to archive this task?"
          }
          buttonText="Archive"
        />
      </div>
      {/* <div className="mark-completed">
        <ConfirmationPopup
          open={isMarkPopupOpen}
          onCancel={() => setIsEditPopupOpen(false)}
          onOkay={handleMarkMeetingCompleted}
          title="Mark Completed"
          note="Are you sure you want to mark this meeting as completed?"
          buttonText="Confirm"
          Icon={ConfirmInfo}
          className="mark-completed-confirmation"
        />
      </div> */}
      <div className="mark-completed">
        <ConfirmationPopup
          open={isArchivePopupOpenForMeeting}
          onCancel={() => {
            setIsArchivePopupOpenForMeeting(false);
            setMeetingToDelete(null);
          }}
          onOkay={confirmDeleteMeeting}
          title="Archive Meeting"
          note={
            meetingToDelete
              ? `Are you sure you want to archive the "${meetingToDelete.title}"?`
              : "Are you sure you want to archive this meeting?"
          }
          buttonText="Archive"
        />
      </div>
      <div className="mark-completed">
        <ConfirmationPopup
          open={isArchiveForCallPopupOpen}
          onCancel={() => {
            setIsArchiveForCallPopupOpen(false);
            setCallToDelete(null);
          }}
          onOkay={confirmDeleteCall}
          title="Archive Call"
          note={
            callToDelete
              ? `Are you sure you want to archive the call "${callToDelete.subject}"?`
              : "Are you sure you want to archive this call?"
          }
          buttonText="Archive"
        />
      </div>
      <CommonRescheduleCallDialog
        open={rescheduleCallOpen}
        onClose={() => {
          setRescheduleCallOpen(false)
          setEditDataCall(null);
        }
      }
        initialCall={editDataCall}
        onSave={() => {
          fetchCalls();
          setRescheduleCallOpen(false);
          setEditDataCall(null);
        }}
        title="Reschedule"
        campaignDetails={campaignDetails}
      />
    
      <CancelCallDialog
        open={cancelCallOpen}
        onClose={() => {
          setCancelCallOpen(false)
          setEditDataCall(null);
        }}
        initialCall={editDataCall}
        onSave={() => {
          fetchCalls();
          fetchCalls("closed");
          setCancelCallOpen(false);
          setEditDataCall(null);
        }}
        title="Cancel"
        campaignDetails={campaignDetails}
      />
    </>
  );
};

export default CampaignViewDetailsViewActivitiesInfo;
